import MicroNutrients from './MicroNutrients'
export default MicroNutrients;